import { render, staticRenderFns } from "./CompetitionFilterDefaultFilter.vue?vue&type=template&id=bb73d916&scoped=true"
import script from "./CompetitionFilterDefaultFilter.vue?vue&type=script&lang=js"
export * from "./CompetitionFilterDefaultFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb73d916",
  null
  
)

export default component.exports